import React, { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Fab from "@mui/material/Fab";
import WhatsApp from "@mui/icons-material/WhatsApp";
import { fontSize, styled } from "@mui/system";
import { useTheme, useMediaQuery, useScrollTrigger } from "@mui/material";
import { useRecoilValue } from "recoil";
import { activeTabState } from "src/SearchHours/state/atoms";

const StyledFab = styled(Fab)(({ theme }) => ({
  border: "2px solid",
  borderColor: "#25D366",
  backgroundColor: "#FFFFFF",
  color: "#25D366",
  transition: "background-color 0.3s ease, transform 0.2s ease",
  paddingRight: 0,
  "&:hover": {
    backgroundColor: "#25D366",
    color: "#FFFFFF",
  },
  [theme.breakpoints.up("lg")]: {
    position: "sticky",
    paddingLeft: theme.spacing(1),
  },
  [theme.breakpoints.down("md")]: {
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    position: "fixed",
    backgroundColor: "#25D366",
    color: "#FFFFFF",
  },
  "& .fab-text": {
    whiteSpace: "nowrap", // Mantiene el texto en una línea
  },
}));

const WhatsAppIcon = styled(WhatsApp)(({ theme }) => ({
  transition: "transform 0.2s ease",
  color: "#FFFFFF",
  backgroundColor: "#25D366",
  borderRadius: "50%",
  marginLeft: theme.spacing(1),
  marginRight: "-10px",
  padding: "5px",
  [theme.breakpoints.down("md")]: {
    fontSize: 42,
    marginRight: 0,
    marginLeft: 0,
    padding: 0,
  },
}));

export default function WhatsAppFab({
  sizeIcon = 72,
  fontSizeText = 16,
  ...props
}) {
  const activeTab = useRecoilValue(activeTabState);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  let message = "";
  if(process.env.REACT_APP_SEDE == "Los Ángeles"){
    message = encodeURIComponent("Hola Andrea, quiero agendar una cita en Los Ángeles");
  }else if(process.env.REACT_APP_SEDE == "Ancud"){
      message = encodeURIComponent("Hola Andrea, quiero agendar una cita en Ancud");
  }else{
    message = encodeURIComponent("Hola Andrea, quiero agendar una cita");
  }

  const phone = process.env.REACT_APP_WHATSAPP || "";

  if (activeTab !== "1") {
    return null;
  }

  if (!phone) {
    return null;
  }

  const url = `https://api.whatsapp.com/send/?phone=${phone}&text=${message}`;

  return (
    <StyledFab
      color="primary"
      aria-label="wsp"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant={isSmallScreen ? "round" : "extended"}
      {...props}
    >
      {!isSmallScreen && (
        <span className="fab-text" style={{ fontSize: fontSizeText }}>
          ¿Quieres agendar una hora?
        </span>
      )}
      <WhatsAppIcon
        sx={{
          fontSize: { md: sizeIcon, lg: sizeIcon + 8 },
        }}
      />
    </StyledFab>
  );
}
